import sdk from './sdk';
import saveTemplate from '@webapp-next/lib/request/webapp/schedule/template/save';
import request from './request';

window.__APP__ = window.__APP__ || {};
window.__APP__.SCHEDULE = window.__APP__.SCHEDULE || {};
window.__APP__.SCHEDULE.request = window.__APP__.SCHEDULE.request || {};
window.__APP__.SCHEDULE.sdk = window.__APP__.SCHEDULE.sdk || {};
window.__APP__.SCHEDULE.sdk = {
  ...window.__APP__.SCHEDULE.sdk,
  ...sdk,
};
window.__APP__.SCHEDULE.request = {
  ...window.__APP__.SCHEDULE.request,
  ...request,
  saveTemplate,
};

// retrofeed: classic consumers still reference window.deputySdk.schedule
window.deputySdk = window.deputySdk || {};
window.deputySdk.schedule = sdk;
